import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AdminServices, GlobalService, PreaprovalServices } from '@app/services';
import moment from 'moment';import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-generate-preapprovals-mrp',
    templateUrl: './generate-preapprovals-mrp.component.html',
    styleUrls: ['./generate-preapprovals-mrp.component.scss'],
    standalone: false
})
export class GeneratePreapprovalsMrpComponent implements OnInit {
  permissionAccess: boolean = false;
  jsonParameters: Array<Object> = []
  dateSelected: any = {
    "from": '2022-11-15',
    "to": '2023-12-01'
  }
  isRefill:boolean = false;

  merchantsCaptured:any = null
  json: any = []
  numbers: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  numbersShort: any = [1, 2, 3]
  statesMx: any = ["Baja California Sur", "Michoacan de Ocampo", "Ciudad de Mexico", "San Luis Potosi", "Baja California", 
                "Aguascalientes", "Quintana Roo", "Nuevo Leon", "Guanajuato", "Chihuahua", "Queretaro", "Veracruz", "Coahuila", "Coahuila", "Jalisco", "Yucatan",
                "Hidalgo", "Morelos", "Puebla", "Mexico", "Sonora" ];

  fields: any[] = [];
  generalForm: UntypedFormGroup;


  dynamicForm: UntypedFormGroup;
  importantJsonKeys: any = [];
  descriptionKeys: Array<any> = [];
  partners: any = [];
  partnerSelected: any = null;
  constructor(
    private prepaprovalsServices: PreaprovalServices,
    private global: GlobalService,
    private formBuilder: UntypedFormBuilder,
    private adminServices:AdminServices
  ) { }

  ngOnInit(): void {
    this.verifyPermissionAccess();
    this.prepaprovalsServices.getTempleteParametersProcessPreapprovalsPython().subscribe((response)=>{
      if(!response.error){
        this.jsonParameters = response.data;
        this.descriptionKeys = this.jsonParameters['description_parameters']
      }else{
        this.global.prepareAlert({
          "message": `Error al obtener plantilla, - ${response.message}`,
          "title": "Error",
          "label": "error"
        }).subscribe((res)=>{})
      }
    })
    this.getProviders();
  }
  
  async getProviders(){
    let partnersFetched = await firstValueFrom(this.adminServices.getAllProviders())
    if(!partnersFetched.error){
      this.partners = partnersFetched.data;
      for(let partner of this.partners){
        switch(partner.product_type){
          case 1:
            partner.view_name = `${partner.name} - mca`
            break;
          case 2:
            partner.view_name = `${partner.name} - factoring`
            break;

          case 3:
            partner.view_name = `${partner.name} - discount`
            break;
    
        }
      }
    }else{
      this.global.prepareAlert({
        "message": `Error al obtener partners, - ${partnersFetched.message}`,
        "title": "Error",
        "label": "error"
      }).subscribe((res)=>{})
    }
  }

  setPartner(partner:any){
    this.partnerSelected = partner;
    this.json = this.jsonParameters[`${this.partnerSelected.name.toLowerCase()}`]['traditional'];
    this.buildForm()
  }
  createDynamicForm(json: any) {

    let formGroup = this.formBuilder.group({});

    for(let mainProperty in json){
      let propertyData = json[mainProperty]
      if(typeof propertyData === 'object' && !Array.isArray(propertyData)){
        formGroup.addControl(mainProperty, this.createDynamicForm(propertyData));
      }else{
        formGroup.addControl(mainProperty, new UntypedFormControl(propertyData));
      }
    }
    
    return formGroup;
  }


  returnChildForm(name:any){
    return (this.generalForm.get(name) as UntypedFormGroup).controls
  }

  buildForm() {
    this.dynamicForm = this.createDynamicForm(this.json);
    this.importantJsonKeys = Object.keys(this.json);
  }

  public getControlNames(formGroup: UntypedFormGroup){
    return Object.keys(formGroup.controls);
  }

  public isNestedGroup(formGroup: UntypedFormGroup, control: string){
    return formGroup.get(control) instanceof UntypedFormGroup;
  }

  view(){
    if(this.dateSelected.from && this.dateSelected.to){
        this.global.prepareModal({
          "title": "Confirmacion", 
          "message": "Estas seguro de ejecutar el proceso con los parametros anteriores?"
        }).subscribe(res=>{
          
          if(res === "ok"){
            this.jsonParameters[`${this.partnerSelected.name.toLowerCase()}`]['traditional'] = this.dynamicForm.value
            let data = {
              "start_date": moment(this.dateSelected.from).format('YYYY-MM-DD'),
              "end_date": moment(this.dateSelected.to).format('YYYY-MM-DD'),
              "provider_name": `${this.partnerSelected.name.toLowerCase()}`,
              "merchants": this.merchantsCaptured ? this.merchantsCaptured : '',
              "is_refill": this.isRefill ? 1 : 0,
              "json_parameters": this.jsonParameters
            }
            this.prepaprovalsServices.sendTemplateAndExecuteProcess(data).subscribe((response)=>{
              if(!response.error){  
                this.global.prepareAlert({
                  "message": "Se inicio exitosamente el proceso...",
                  "title": "Exito",
                  "label": "success"
                }).subscribe((res)=>{})
              }else{
                this.global.prepareAlert({
                  "message": `Error al iniciar el proceso ${response.message}`,
                  "title": "Error",
                  "label": "error"
                }).subscribe((res)=>{})
              }
            });
          }
        })
    }else{
      this.global.prepareAlert({
        "message": "Fechas invalidas",
        "title": "Error",
        "label": "error"
      }).subscribe((res)=>{})
    }
  }

  verifyPermissionAccess(){
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if(modulesPermission.includes('generate_preapprovals_mrp')){
      this.permissionAccess = true;
    }
  }


}
